import { render } from "./form2.vue?vue&type=template&id=1882d455&scoped=true"
import script from "./form2.vue?vue&type=script&lang=js"
export * from "./form2.vue?vue&type=script&lang=js"

import "./form2.vue?vue&type=style&index=0&id=1882d455&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1882d455"]])

export default __exports__